// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1t4_n","name":"styles_name__2Jjk9","phone":"styles_phone__7C-3v"};